import { useRef, useState, useEffect } from "react";
import SensorStatusFocusStyle from "./css/SensorStatusFocus.module.css";
import colorToRgba from "../../../shared/utils/colorToRgba";

type SensorStatusFocusProps = {
    index: number;
    itemAmount: number;
    color: string;
    immediate?: boolean;
    filled?: boolean;
    colorful?: boolean;
}

function SensorStatusFocus({ index, itemAmount, color, immediate = false, filled = true, colorful = false }: SensorStatusFocusProps) {
    const nodeRef = useRef<HTMLDivElement>(null);
    const [delayedIndex, setDelayedIndex] = useState(index);
    
    // index 변경 시 50ms 딜레이 후 위치 업데이트 (지도 렌더링과 겹치지 않도록)
    useEffect(() => {
        const timer = setTimeout(() => {
            setDelayedIndex(index);
        }, 100);
        
        return () => clearTimeout(timer);
    }, [index]);
    
    let backgroundColor: any = colorful ? colorToRgba(color, 0.2) : "#3E63ED";
    backgroundColor = filled ? backgroundColor : undefined;

    return (
        <div
            ref={nodeRef}
            className={SensorStatusFocusStyle.focus}
            style={{
                height: `${100 / itemAmount}%`,
                top: `${(100 / itemAmount) * delayedIndex}%`,
                boxShadow: `0 0 ${color ? 4 : 16}px 0 ${color}`,
                border: `1px solid ${color}`,
                backgroundColor,
                pointerEvents: "none",
                ...(immediate ? { transition: "none" } : {}),
            }}
        >
        </div>
    );
}

export default SensorStatusFocus;